export function deduplicateArr<T, K extends keyof T>(array: T[], key?: K): T[] {
  const map = new Map<unknown, T>();

  for (const item of array) {
    const dedupeKey = key !== undefined ? (item as T)[key] : item;
    map.set(dedupeKey, item);
  }

  return Array.from(map.values());
}
